import { State } from 'src/redux/reducer';
import { isLoaded, isPending, shouldLoad } from 'src/redux/utils';

export const allModelsSelector = (state: State) => state.allModels.entities;
export const allModelsStatusSelector = (state: State) => state.allModels.status;
export const allModelsLoadedSelector = isLoaded(allModelsStatusSelector);
export const allModelsPendingSelector = isPending(allModelsStatusSelector);
export const shouldAllModelsSelector = shouldLoad(allModelsStatusSelector);
